import React, { useEffect, useState } from 'react';
import './Home.css';
import Animation from '../../ui/components/animation/Animation';
import AIHeroSection from './components/AIHeroSection';
import HeroSection from './components/HeroSection';
import BuiltForSection from './components/BuiltForSection';
import ServicesSection from './components/ServicesSection';
import PlatformFeaturesSection from './components/PlatformFeaturesSection';
import SuccessStoriesSection from './components/SuccessStoriesSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

const Home = () => {
   const [showAnimation, setShowAnimation] = useState(() => {
      // Check if animation has already been shown
      const hasShownAnimation = localStorage.getItem('hasShownAnimation');
      return !hasShownAnimation; // Show animation only if it hasn't been shown before
   });

   useEffect(() => {
      if (showAnimation) {
         // Hide animation after 3 seconds automatically
         const animationTimer = setTimeout(() => {
            setShowAnimation(false);
            // Mark that animation has been shown
            localStorage.setItem('hasShownAnimation', 'true');
         }, 3000);

         // Cleanup timer on unmount
         return () => {
            clearTimeout(animationTimer);
         };
      }
   }, [showAnimation]);

   return (
      <div className="home-page">
         <AIHeroSection />
         <HeroSection />
         {showAnimation && <div className="animation-section"><Animation /></div>}
         <BuiltForSection />
         <ServicesSection />
         <PlatformFeaturesSection />
         <SuccessStoriesSection />
         <FAQSection />
         <ContactSection />
      </div>
   );
};

export default Home;
